<template>
  <div id="overlay" v-if="showAdultContentWarning">
    <div id="info" class="p-3 pt-4 pb-4 shadow">
      <img id="image" :src="image_path" class="mb-3" />
      <h3>{{ translations.header }}</h3>
      <p>{{ translations.description }}</p>
      <h4>{{ translations.question }}</h4>
      <div class="row mt-2 mt-sm-4">
        <div class="col-xs-24 col-sm-12">
          <button @click="back" class="btn btn-primary-link btn-lg">
            {{ translations.false }}
          </button>
        </div>
        <div class="col-xs-24 col-sm-12">
          <button @click="setCookie" class="btn btn-primary btn-lg">{{ translations.true }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AdultContentWarning",
  props: {
    image_path: {
      required: true,
      type: String,
    },
    translations: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      showAdultContentWarning: "currentUser/showAdultContentWarning",
    }),
  },
  watch: {
    showAdultContentWarning: {
      handler(show) {
        if (show) {
          document.querySelector(".sw-Body_Inner").classList.add("sw-Body-blurred");
        } else {
          document.querySelector(".sw-Body_Inner").classList.remove("sw-Body-blurred");
        }
      },
      immediate: true,
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    setCookie() {
      document.cookie =
        "adult_content=true;expires=" +
        new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365).toUTCString() +
        ";path=/";
      this.fetchAdultContentCookie();
    },
    ...mapActions({
      fetchAdultContentCookie: "currentUser/fetchAdultContentCookie",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

#image {
  width: 150px;
  height: 150px;
}

#overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  display: grid;
  place-items: center center;

  /* edge */
  justify-content: center;
  align-items: center;
}

#info {
  width: 100%;
  max-width: 550px;
  background: $white;
  text-align: center;
}
</style>
